module.exports = __webpack_public_path__ + "img/icon (9).d2400b0c.png";